{
  "name": "@meilisearch/instant-meilisearch",
  "version": "0.31.3",
  "description": "The search client to use Meilisearch with InstantSearch.",
  "homepage": "https://github.com/meilisearch/meilisearch-js-plugins/tree/main/packages/instant-meilisearch",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/meilisearch/meilisearch-js-plugins/issues"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/meilisearch/meilisearch-js-plugins.git"
  },
  "author": {
    "name": "Meilisearch",
    "url": "https://meilisearch.com"
  },
  "keywords": [
    "search",
    "instantsearch",
    "client"
  ],
  "scripts": {
    "build": "vite build && tsc"
  },
  "engines": {
    "node": "^20.19.0 || >=22.12.0"
  },
  "type": "module",
  "exports": {
    ".": "./src/index.ts"
  },
  "publishConfig": {
    "access": "public",
    "exports": {
      ".": "./dist/index.js",
      "./package.json": "./package.json"
    }
  },
  "sideEffects": false,
  "files": [
    "dist",
    "src",
    "templates"
  ],
  "peerDependencies": {
    "meilisearch": "catalog:"
  }
}
